export default {
  "brand.name": "USFansLink",
  "nav.home": "Inicio",
  "nav.guide": "Guía de la hoja",
  "nav.shopping": "Guía de compras",
  "nav.categories": "Categorías",
  "nav.visit": "Visitar el sitio principal",
  "lang.en": "English",
  "lang.pl": "Polski",
  "lang.es": "Español",
  "lang.fr": "Français",
  "footer.tagline": "Un centro de recursos independiente para la hoja de USFans.",
  "footer.navTitle": "Explorar",
  "footer.resourcesTitle": "Recursos",
  "footer.disclaimerTitle": "Aviso legal",
  "footer.disclaimer": "USFansLink.asia es un recurso informativo independiente. No estamos afiliados con USFans ni con el sitio principal. Verifica siempre la información actual antes de realizar compras o pagos.",
  "footer.home": "Inicio",
  "footer.guide": "Guía de la hoja",
  "footer.mainSite": "Sitio principal",
  "footer.copyright": "© 2026 USFansLink.asia. Todos los derechos reservados.",
  "notfound.title": "Página no encontrada",
  "notfound.body": "La página que buscas no existe o ha sido movida.",
  "notfound.home": "Volver al inicio",
};